/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from "react";
import {
  Button,
  Container,
  Responsive,
  Header,
  Grid,
  Segment,
  Popup,
  Icon
} from "semantic-ui-react";

import * as CONSTANTS from "../assets/Constants";
import * as LINKS from "../assets/Links";
// import ProjectCard from "./ProjectCard";
import MemberProfile from "./MemberProfile";

class Footer extends Component {
  render() {
    return (
      <Responsive>
        <Segment
          inverted
          vertical
          style={{
            padding: "3em 0em",
            backgroundColor: "#111111" /* , marginTop: "3em" */
          }}
        >
          <Container>
            <Grid /* columns="equal" */ stackable textAlign='center'>
            <Header textAlign='center' inverted as="h4" content="Connect with us on" />

              <Grid.Row centered>
                {/* <Grid.Column width={8}> */}
                  <div>
                    <Button
                      circular
                      size="big"
                      href={LINKS.FB_BLOGS_LINK}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="facebook"
                      icon="facebook"
                    />
                    <Button
                      circular
                      size="big"
                      href={LINKS.IG_LINK}
                      target="_blank"
                      rel="noopener noreferrer"
                      icon="instagram"
                    />
                    <Button
                      circular
                      size="big"
                      href={LINKS.MEDIUM_BLOGS_LINK}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="grey"
                      icon="medium m"
                    />
                    <Button
                      circular
                      href={LINKS.GMAIL_LINK}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="big"
                      color="google plus"
                      icon="mail"
                    />
                    <Popup
                      key="location"
                      trigger={
                        <Button
                          circular
                          size="big"
                          color="green"
                          icon="map pin"
                        />
                      }
                      header="Meet us at our Clubroom"
                      content="VV 306, SASTRA Deemed University, Thanjavur, Tamil Nadu"
                    />
                  </div>
                {/* </Grid.Column> */}
                {/* <Grid.Column width={8} textAlign="right">
                  <Header as="h5" inverted>
                    The site is under construction and maintained by the RCS
                    club members.
                  </Header>
                  <Header as="h5" inverted>
                    Projects Pages will be added soon.
                  </Header>
                  <Header as="h5" inverted>
                    RCS Team
                  </Header>
                </Grid.Column> */}
              </Grid.Row>
              <Grid.Row>
                <Grid.Column textAlign="right">
                  <Header
                    as="h6"
                    style={{
                      marginTop: "1em",
                      color: "gray",
                      fontSize: "0.85em"
                    }}
                    // size="tiny"
                    textAlign="center"
                  >
                    This web-app runs with React on Frontend and Flask with
                    PostgreSQL DB on Backend!
                    <br/><br/>
                    <div>
                      <Icon size="large" name="react" />
                      <Icon size="large" name="python" />
                      <Icon size="large" name="database" />
                    </div>
                    <br/>
                    <Header
                      style={{
                        marginTop: "1em",
                        color: "gray",
                        fontSize: "0.9em"
                      }}
                      textAlign="center"
                    >
                      Crafted with 🔥 By{" "}
                      <MemberProfile
                        key="lazyV"
                        data={CONSTANTS.CraftedByV}
                        type="LABEL"
                        size="mini"
                      />
                    </Header>
                    
                  </Header>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
      </Responsive>
    );
  }
}

export default Footer;
